const TransportType = {
  EMAIL: 1,
  EMAIL_SMS: 2, // email-to-sms
  IN_APP: 3, // mobile push notification
  DEVICE: 4,
  WEBHOOK: 5, // http post
  SMS: 6, // text msg
};

export default TransportType;
